// removed by extract-text-webpack-plugin
module.exports = {"packageBlock":"_1ZyoYKm4Eel1WVRBw-aQB5"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/PackageBlock.scss
// module id = 1590
// module chunks = 0